import React, { useState } from 'react';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';

export type ExportMenuButtonProps = {
  tooltip: string;
  exportLabel: string;
  copyLabel: string;
  onExport: () => void | Promise<void>;
  onCopy: () => void | Promise<void>;
  disabled?: boolean;
};

const ExportMenuButton: React.FC<ExportMenuButtonProps> = ({
  tooltip,
  exportLabel,
  copyLabel,
  onExport,
  onCopy,
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = () => setAnchorEl(null);

  const handleAction = (action: () => void | Promise<void>) => {
    handleClose();
    void action();
  };

  return (
    <>
      <Tooltip title={tooltip}>
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          <IconButton
            size='small'
            aria-label={tooltip}
            disabled={disabled}
            onClick={(event) => setAnchorEl(event.currentTarget)}
            sx={{
              color: '#878B8E',
              '&:hover': {
                color: '#4A90E2',
                backgroundColor: 'rgba(74, 144, 226, 0.08)',
              },
            }}
          >
            <FileDownloadOutlinedIcon fontSize='small' />
          </IconButton>
        </span>
      </Tooltip>

      <Menu
        disableAutoFocusItem
        disableScrollLock
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: '#FFF',
            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.20)',
            borderRadius: '8px',
          },
        }}
      >
        <MenuItem onClick={() => handleAction(onExport)}>
          <ListItemIcon>
            <FileDownloadOutlinedIcon fontSize='small' />
          </ListItemIcon>
          {exportLabel}
        </MenuItem>

        <MenuItem onClick={() => handleAction(onCopy)}>
          <ListItemIcon>
            <ContentCopyOutlinedIcon fontSize='small' />
          </ListItemIcon>
          {copyLabel}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ExportMenuButton;
